import SearchIcon from '@mui/icons-material/Search';
import { Box, Chip, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReusableTable from '../../common/table/CommonTable';
import { fetchTransferPatient } from '../../redux/TransferPatient/transferPatientAction';

const OverAllHistoryList = () => {
  const dispatch = useDispatch();
  const transferState = useSelector((state) => state?.transferPatient?.fetchListTransferPatient || {});
  console.log(transferState, "transferState");
  const isLoading = useSelector((state) => state?.transferPatient?.inProgress || false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
 const fetchData = async (page) => {
      await dispatch(fetchTransferPatient(page));
      setLoading(false);
    };
    useEffect(() => {
      fetchData(currentPage);
    }, [currentPage, dispatch]);


    const totalPages =transferState?.data.totalPages || 0
    console.log(totalPages, "totalPages");
  useEffect(() => {
    if (Array.isArray(transferState?.data?.data)) {
      const processed = transferState.data.data.map((item, index) => ({
        serialNo: index + 1,
        id: item.id,
        patientName: item.Patient?.patient_name || 'N/A',
        ipNumber: item.Patient?.ip_number || 'N/A',
        phoneNumber: item.Patient?.phone || 'N/A',
        staffName: item.Staff?.staff_name || 'N/A',
        oldBlock: item.old_Block?.block_name || 'N/A',
        oldFloor: item.old_Floor?.floor_name || 'N/A',
        oldWard: item.old_Ward?.ward_name || 'N/A',
        newBlock: item.new_Block?.block_name || 'N/A',
        newFloor: item.new_Floor?.floor_name || 'N/A',
        newWard: item.new_Ward?.ward_name || 'N/A',
        transferDate: new Date(item.createdAt).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        }),
        reason: item.reason || 'N/A'
      }));
      setProcessedData(processed);
      setFilteredData(processed);
    } else {
      setProcessedData([]);
      setFilteredData([]);
    }
  }, [transferState]);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredData(processedData);
    } else {
      const lowercasedSearch = searchTerm.toLowerCase();
      const filtered = processedData.filter(item => 
        String(item.patientName).toLowerCase().includes(lowercasedSearch) ||
        String(item.ipNumber).toLowerCase().includes(lowercasedSearch) ||
        String(item.phoneNumber).toLowerCase().includes(lowercasedSearch) ||
        String(item.staffName).toLowerCase().includes(lowercasedSearch) ||
        String(item.oldBlock).toLowerCase().includes(lowercasedSearch) ||
        String(item.oldFloor).toLowerCase().includes(lowercasedSearch) ||
        String(item.oldWard).toLowerCase().includes(lowercasedSearch) ||
        String(item.newBlock).toLowerCase().includes(lowercasedSearch) ||
        String(item.newFloor).toLowerCase().includes(lowercasedSearch) ||
        String(item.newWard).toLowerCase().includes(lowercasedSearch) ||
        String(item.transferDate).toLowerCase().includes(lowercasedSearch) ||
        String(item.reason).toLowerCase().includes(lowercasedSearch)
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, processedData]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const columns = [
    { id: 'serialNo', label: 'S.No', sortable: true },
    { id: 'patientName', label: 'Patient Name', sortable: true },
    { id: 'ipNumber', label: 'IP Number', sortable: true },
    { id: 'phoneNumber', label: 'Phone Number', sortable: true },
    { id: 'staffName', label: 'Staff', sortable: true, 
      render: (value) => (
        <Chip label={value} color="primary" size="small" />
      )
    },
    { 
      id: 'oldBlock', 
      label: 'Old Block', 
      sortable: true,
      render: (value) => (
        <Chip label={value} color="warning" size="small" />
      )
    },
    { 
      id: 'oldFloor', 
      label: 'Old Floor', 
      sortable: true,
      render: (value) => (
        <Chip label={value} color="warning" size="small" />
      )
    },
    { 
      id: 'oldWard', 
      label: 'Old Ward', 
      sortable: true,
      render: (value) => (
        <Chip label={value} color="warning" size="small" />
      )
    },
    { 
      id: 'newBlock', 
      label: 'New Block', 
      sortable: true,
      render: (value) => (
        <Chip label={value} color="success" size="small" />
      )
    },
    { 
      id: 'newFloor', 
      label: 'New Floor', 
      sortable: true,
      render: (value) => (
        <Chip label={value} color="success" size="small" />
      )
    },
    { 
      id: 'newWard', 
      label: 'New Ward', 
      sortable: true,
      render: (value) => (
        <Chip label={value} color="success" size="small" />
      )
    },
    { id: 'transferDate', label: 'Transfer Date', sortable: true },
    { id: 'reason', label: 'Reason', sortable: true }
  ];

  return (
    <Box>
      <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
        <Typography variant="subtitle1" gutterBottom>
          Search Transfer History
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search by patient name, IP number, staff, ward, block, reason, etc."
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          size="small"
        />
      </Paper>

      <ReusableTable
        title="Patient Transfer History"
        columns={columns}
        data={filteredData}
        isLoading={isLoading}
        headerColor="#000" 
        rowColor="#ffffff" 
        alternateRowColor="#f5f5f5" 
        withPagination={true}
        withActions={false}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        showDownloadOption={true} 
      />
    </Box>
  );
};

export default OverAllHistoryList;